var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlackberry = function SvgBlackberry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blackberry_svg__a)",
    d: "M135 200c33.137 0 60-25.52 60-57s-26.863-57-60-57-60 25.52-60 57 26.863 57 60 57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blackberry_svg__b)",
    d: "M141.226 88.675c-1.551-2.768-3.755-8.021-4.591-16.492a2.39 2.39 0 0 0-.972-1.715 2.4 2.4 0 0 0-1.928-.409c-2.809.632-7.21 1.9-10.187 4.086a2.356 2.356 0 0 0-.63 3.065 17.76 17.76 0 0 1 2.074 11.725c-3.047.527-4.987 1.314-4.987 2.2 0 1.585 6.268 2.87 14 2.87s14-1.285 14-2.87c-.005-1.047-2.725-1.957-6.779-2.46"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blackberry_svg__a",
    x1: 135,
    x2: 135,
    y1: 86,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blackberry_svg__b",
    x1: 134.005,
    x2: 134.005,
    y1: 94.005,
    y2: 56.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1485B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#1988B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#2A90BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#459EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#6BB2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#9BCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#D6E9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgBlackberry;